var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26316 21.8772H5.17544C2.86941 21.8772 1 23.7466 1 26.0526V36.4912C1 38.7973 2.86941 40.6667 5.17544 40.6667H7.26316C9.56919 40.6667 11.4386 38.7973 11.4386 36.4912V26.0526C11.4386 23.7466 9.56919 21.8772 7.26316 21.8772Z",
    fill: "white",
    stroke: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9649 11.4386H21.8772C19.5712 11.4386 17.7018 13.308 17.7018 15.614V36.4912C17.7018 38.7972 19.5712 40.6666 21.8772 40.6666H23.9649C26.271 40.6666 28.1404 38.7972 28.1404 36.4912V15.614C28.1404 13.308 26.271 11.4386 23.9649 11.4386Z",
    fill: "white",
    stroke: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6666 1H38.5789C36.2728 1 34.4034 2.86941 34.4034 5.17544V36.4912C34.4034 38.7973 36.2728 40.6667 38.5789 40.6667H40.6666C42.9726 40.6667 44.842 38.7973 44.842 36.4912V5.17544C44.842 2.86941 42.9726 1 40.6666 1Z",
    fill: "white",
    stroke: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.6b1217e1d8f8599c3f69d9c56c336218.svg";
export { ForwardRef as ReactComponent };